<template>
  <div>
    <transition name="sheet-fade">
      <div v-if="display" class="sheet-overlay" @click="hideSheet"></div>
    </transition>
    <transition name="sheet-slide">
      <div v-if="display" class="sheet-content">
        <slot>
          <div>Bottomsheet Placeholder</div>
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "BottomSheet",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      display: false,
      navGuard: null,
    };
  },
  methods: {
    showSheet: function() {
      this.display = true;
    },
    hideSheet: function() {
      this.display = false;
    },
  },
});
</script>

<style lang="postcss" scoped>
.sheet-overlay {
  @apply fixed h-screen w-screen min-h-screen top-0 left-0;
  background: rgba(0, 0, 0, 0.6);
}
.sheet-content {
  @apply fixed rounded-t-lg bottom-0 bg-white left-0 w-full opacity-100 pt-5;
  height: 80%;
  overflow-y: scroll;
  -ms-overflow-style: none;
}

.sheet-content::-webkit-scrollbar {
  display: none;
}
</style>

<style scoped>
.sheet-fade-enter,
.sheet-fade-leave-active {
  opacity: 0;
}

.sheet-fade-enter-active,
.sheet-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>

<style scoped>
.sheet-slide-enter,
.sheet-slide-leave-active {
  transform: translateY(110%);
}

.sheet-slide-enter-active,
.sheet-slide-leave-active {
  transition: all 0.3s ease;
}
</style>
